import { IAdvert } from 'interfaces/IAdvert';
import { IAccount } from 'interfaces/IAccount';
import { IBadge } from 'interfaces/IBadge';
import AdvertDataModel from 'models/AdvertDataModel';
import AccountDataModel from 'models/AccountDataModel';
import cn from 'classnames';

class CardDataModel {
  readonly advert: AdvertDataModel;
  readonly account: AccountDataModel;

  constructor(advert: IAdvert, account: IAccount) {
    this.advert = new AdvertDataModel(advert);
    this.account = new AccountDataModel(account);
  }

  get badges(): IBadge[] {
    // @ts-ignore
    return [
      { text: this.advert.vinChecked && 'VIN проверен' },
      { text: this.advert.withDriver && 'Аренда с водителем' },
      { text: this.advert.onOrder && 'Под заказ', gray: true },
    ].filter((badge) => !!badge.text);
  }

  get advertTypeClassNames(): string {
    return cn({
      sale: this.advert.isSale,
      rent: this.advert.isRent,
      purchase: this.advert.isPurchase,
    });
  }
}

export default CardDataModel;
